import React from 'react'
import config from '../config.json';
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import { Facebook, Instagram, LinkedIn,Mail } from "@mui/icons-material";
import  Box  from "@mui/material/Box";
import useMediaQuery from '@mui/material/useMediaQuery'


function Footer() {
  const isMobile= useMediaQuery("(max-width:600px)");
  const gmailAddress=config[process.env.REACT_APP_HOST_NAME]?.data?.email;
  const Mailto=`https://mail.google.com/mail/?view=cm&to=${gmailAddress}&su=Hello`;
 

  const linkStyle = { marginRight: 5, color: config[process.env.REACT_APP_HOST_NAME].css.headerFontColor };

  return (
   
    <Box component="footer"sx={{backgroundColor: config[process.env.REACT_APP_HOST_NAME].css.websiteColor,textAlign:"center"}}>
      <Container maxWidth="lg">
        <Grid container spacing={10} >
        {!isMobile && (
            <Grid item xs={12} sm={4} >
                <Typography variant="h6" style={{marginLeft:20,textAlign:"left",color: config[process.env.REACT_APP_HOST_NAME].css.headerFontColor}} gutterBottom>
                  <a href='/about' style={{color: config[process.env.REACT_APP_HOST_NAME].css.headerFontColor}}>
                    About Us
                  </a>
                </Typography>
                <Typography variant="body1" style={{marginLeft:20,textAlign:"left",color: config[process.env.REACT_APP_HOST_NAME].css.headerFontColor}}>
                Today building strong families, inclusive workforces and revitalising the earth or our neighbors is not considered work.
                Helping people to get comfortable with receiving and giving to further goodwill.
                </Typography>
            </Grid>
          )}
            <Grid item xs={12} sm={4}>
              <Typography style={{marginLeft:isMobile?60:90,textAlign:"left"}}>
              <a style={{ textDecoration:"none",fontSize:18 ,marginTop: isMobile?0:10, textAlign:"left",color: config[process.env.REACT_APP_HOST_NAME].css.headerFontColor, }} href='/terms' target='_blank' rel='noopener noreferrer'>Terms and conditions</a>
              <br/>
              <a style={{ textDecoration:"none",fontSize:18, marginBottom:isMobile?0:20,textAlign:"left",color: config[process.env.REACT_APP_HOST_NAME].css.headerFontColor }} href='/refund-policy' target='_blank' rel='noopener noreferrer'>Fees and Refund Policy</a>
              <br/>
              <a style={{ textDecoration:"none",fontSize:18,marginBottom:isMobile?0:20,textAlign:"left",color: config[process.env.REACT_APP_HOST_NAME].css.headerFontColor }} href='/privacy-policy' target='_blank' rel='noopener noreferrer'>Privacy Policy</a>
              <br/>
              <a style={{ textDecoration:"none",fontSize:18,marginBottom:isMobile?0:20,textAlign:"left",color: config[process.env.REACT_APP_HOST_NAME].css.headerFontColor }} href='/shipping-delivery-policy' target='_blank' rel='noopener noreferrer'>Shipping & Delivery Policy</a>
              </Typography>
            </Grid>

            <Grid item xs={12} sm={4}>
              <Typography variant="h6" style={{marginTop:isMobile?-50:0,color: config[process.env.REACT_APP_HOST_NAME].css.headerFontColor}} gutterBottom>
                Contact Us
              </Typography>
              <Link href="https://www.instagram.com/giftoftime_/" target="_blank" style={linkStyle}>
                <Facebook/>
              </Link>
              <Link href="https://www.instagram.com/giftoftime_/" target="_blank" style={linkStyle}>
                <Instagram/>
              </Link>
              <Link href={Mailto} target="_blank" style={linkStyle}>
                <Mail/>
              </Link>
              <Link href="https://www.linkedin.com/company/gift-of-time-foundation-in/" target="_blank" style={linkStyle}>
                <LinkedIn/>
              </Link>
          </Grid>

        </Grid>
        <Box mt={5}>
          <Typography variant="subtitle2" style={{paddingBottom:10,color: config[process.env.REACT_APP_HOST_NAME].css.headerFontColor}} align="center" >
            {"ALL RIGHTS RESERVED"}
            <br/>
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}



export default Footer